import { Chip, Stack } from "@mui/material"

const CateogoryView = ({ categories, selectedCategory, setSelectedCategory }) => {

    return (
        <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mb: 2 }}>
            {categories.map((cat) => (
                <Chip
                    key={cat.id}
                    label={cat.catgName}
                    color={cat.id === selectedCategory?.id ? "primary" : "default"}
                    onClick={() => setSelectedCategory(cat)}
                    clickable
                    sx={{
                        fontSize: "1rem",     // bigger text
                        height: 40,           // chip height
                        "& .MuiChip-label": {
                            px: 2,              // extra horizontal padding inside
                        },
                    }}
                />
            ))}
        </Stack>
    )
};

export { CateogoryView };